import { inject, Injectable } from "@angular/core";
import { AppointmentEventsService } from "src/app/events/appointment-events.service";

@Injectable()
export class EventsService {
  private readonly appointmentEventsService = inject(AppointmentEventsService);

  register(): void {
    this.appointmentEventsService.register();
  }
}
